module.exports = __webpack_public_path__ + "static/media/balloon2.383ddf9c.png";